import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const BWModalSection = ({ title, description, action, bordered = false, compact = false, className, children }) => (
  <section
    className={classNames('bw_modal_section', className, {
      bw_modal_section_bordered: bordered,
      bw_modal_section_compact: compact,
    })}>
    {title || description || action ? (
      <div className='bw_modal_section_header'>
        <div>
          {title ? <h3>{title}</h3> : null}
          {description ? <p>{description}</p> : null}
        </div>
        {action ? <div className='bw_modal_section_action'>{action}</div> : null}
      </div>
    ) : null}
    <div className='bw_modal_section_content'>{children}</div>
  </section>
);

BWModalSection.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  action: PropTypes.node,
  bordered: PropTypes.bool,
  compact: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default BWModalSection;
